<div class="flex flex-col gap-5 p-1">
  @if (errorMessage()) {
    <div class="p-3 rounded-lg bg-surface border border-danger text-danger text-sm flex items-center gap-2">
      <lucide-icon name="circle-alert" size="18" class="shrink-0 text-danger"></lucide-icon>
      <span>{{ errorMessage() }}</span>
    </div>
  }

  <!-- Document Type Selector -->
  <div>
    <label class="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">
      Document Type <span class="text-danger">*</span>
    </label>
    <app-select
      [options]="typeOptions"
      placeholder="Select document type"
      [ngModel]="documentType()"
      (ngModelChange)="documentType.set($event)"
      size="md"
      class="w-full"
    ></app-select>
    @if (documentType() === 'factoring_schedule') {
      <p class="text-xs text-muted mt-1.5 flex items-center gap-1.5">
        <lucide-icon name="info" size="14" class="text-primary"></lucide-icon>
        <span>Settlement schedule PDF received from the factoring company. In future releases, our AI will automatically match paid loads and fee deductions from this file.</span>
      </p>
    }
  </div>

  <!-- Document Title / Description -->
  <div>
    <label class="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">
      Document Title / Label
    </label>
    <app-input
      placeholder="e.g. Triumph Settlement Schedule #9482"
      [value]="documentTitle()"
      (valueChange)="documentTitle.set($event ?? '')"
      size="md"
      class="w-full"
    ></app-input>
  </div>

  <!-- Drag & Drop Zone -->
  <div>
    <label class="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">
      File <span class="text-danger">*</span>
    </label>

    @if (!selectedFile()) {
      <div
        class="border-2 border-dashed rounded-xl p-6 text-center cursor-pointer transition-colors bg-surface-low hover:bg-surface border-border flex flex-col items-center justify-center gap-2"
        [class.border-primary]="isDragging()"
        [class.bg-primary-low-contrast]="isDragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()"
      >
        <input
          #fileInput
          type="file"
          class="hidden"
          accept=".pdf,.png,.jpg,.jpeg,.csv,.xlsx,application/pdf"
          (change)="onFileSelected($event)"
        />
        <div class="w-12 h-12 rounded-full bg-surface flex items-center justify-center border border-border shadow-xs text-primary">
          <lucide-icon name="upload-cloud" size="24"></lucide-icon>
        </div>
        <div class="text-sm font-medium text-foreground">
          Click to browse or drag & drop file
        </div>
        <div class="text-xs text-muted">
          PDF, PNG, JPG, CSV, or XLSX up to 25MB
        </div>
      </div>
    } @else {
      <!-- Selected File Preview -->
      <div class="p-3 bg-surface border border-border rounded-xl flex items-center justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <div class="w-10 h-10 rounded-lg bg-primary-low-contrast flex items-center justify-center shrink-0 text-primary">
            @if (documentType() === 'factoring_schedule') {
              <lucide-icon name="file-spreadsheet" size="20"></lucide-icon>
            } @else {
              <lucide-icon name="file-text" size="20"></lucide-icon>
            }
          </div>
          <div class="min-w-0">
            <app-text weight="semibold" size="sm" class="truncate block">
              {{ selectedFile()?.name }}
            </app-text>
            <app-text variant="muted" size="xs">
              {{ (selectedFile()?.size || 0) / 1024 | number:'1.0-1' }} KB
            </app-text>
          </div>
        </div>

        <app-button
          variant="ghost"
          size="sm"
          [iconOnly]="true"
          icon="trash-2"
          (click)="removeFile()"
          [disabled]="isUploading()"
        ></app-button>
      </div>
    }
  </div>

  <!-- Optional Notes -->
  <div>
    <label class="block text-xs font-semibold uppercase tracking-wider text-muted mb-1.5">
      Notes / Remarks (Optional)
    </label>
    <app-input
      placeholder="Any additional context regarding this document..."
      [value]="documentNotes()"
      (valueChange)="documentNotes.set($event ?? '')"
      size="md"
      class="w-full"
    ></app-input>
  </div>

  <!-- Modal Action Footer -->
  <div class="flex items-center justify-end gap-3 pt-3 border-t border-border mt-2">
    <app-button
      variant="outline"
      size="md"
      (click)="cancel()"
      [disabled]="isUploading()"
    >
      Cancel
    </app-button>
    <app-button
      variant="primary"
      size="md"
      icon="upload"
      [loading]="isUploading()"
      [disabled]="!selectedFile() || isUploading()"
      (click)="upload()"
    >
      Upload Document
    </app-button>
  </div>
</div>
